import common from '../../../../common.js'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'summaryList',

  data() {
    return {
      // カテゴリ一覧関連
      categorySortKey: 'order',
      categorySortOrder: {
        order: 'asc',
        actAmount: 'asc',
        actProfit: 'asc'
      },

      // 店舗一覧関連
      storeSearchWord: '',
      storeSortKey: 'id',
      storeSortOrder: {
        id: 'asc',
        actAmount: 'asc',
        actProfit: 'asc'
      }
    }
  },

  computed: {
    ...mapGetters('category', [
      'dashboardSelectedCategoryId',
      'category'
    ]),

    ...mapGetters('store', [
      'selectedStoreId',
      'store'
    ]),

    ...mapGetters('summary', [
      'actualSummary',
      'planSummary'
    ]),

    /**
     * カテゴリ一覧
     */
    categorys() {
      return _.orderBy(
        this.getCategorys_(),
        category => category[this.categorySortKey],
        this.categorySortOrder[this.categorySortKey]
      )
    },

    /**
     * 店舗一覧
     */
    stores() {
      return _.orderBy(
        _.filter(
          this.getStores_(),
          store => _.includes(store.name, this.storeSearchWord)
        ),
        store => store[this.storeSortKey],
        this.storeSortOrder[this.storeSortKey]
      )
    },

    /**
     * 金額単位
     */
    moneyUnit() {
      return common.VALUE_RATE.label
    },

    /**
     * 動的CSS
     */
    cssResetSearchWord() {
      return this.storeSearchWord.length === 0 ? 'nodisplay' : ''
    }
  },

  methods: {
    ...mapActions('category', [
      'getCategory',
      'setDashboardSelectedCategoryId',
      'setPredictSelectedCategoryId'
    ]),

    ...mapActions('store', [
      'getStore',
      'setSelectedStoreId'
    ]),

    ...mapActions('summary', [
      'getSummary',
      'setCategoryId',
      'setStoreId'
    ]),

    /**
     * ----- カテゴリ用メソッド -----
     */

    /**
     * カテゴリ一覧取得
     * 合算したサマリデータを返す
     */
    getCategorys_() {
      const list = []
      const act = this.getCategorySummary_(this.actualSummary)
      const plan = this.getCategorySummary_(this.planSummary)

      _.forEach(this.category, (category, key) => {
        list.push({
          id: category.category_id,
          name: category.category_name,
          order: category.sort_order,
          actAmount: act[key].amount,
          planAmount: plan[key].amount,
          actProfit: act[key].profit,
          planProfit: plan[key].profit
        })
      })

      return list
    },

    /**
     * サマリデータをカテゴリ単位に合算
     */
    getCategorySummary_(summary) {
      const cSummary = {}
      _.forEach(this.category, (category, key) => {
        cSummary[key] = { amount: 0, profit: 0 }
      })

      _.forEach(summary, store => {
        _.forEach(store, (category, key) => {
          const sum = _(category).reduce((result, value) => {
            result.amount += value.amount
            result.profit += value.profit
            return result
          }, { amount: 0, profit: 0 })

          cSummary[key].amount += sum.amount
          cSummary[key].profit += sum.profit
        })
      })

      // カテゴリ「全て」を更新
      const allId = '00'
      _.forEach(cSummary, (category, key) => {
        if (key !== allId) {
          cSummary[allId].amount += category.amount
          cSummary[allId].profit += category.profit
        }
      })

      return cSummary
    },

    /**
     * カテゴリ一覧のソート項目、順番を変更
     */
    setCategorySortOption(key) {
      if (this.categorySortKey == key) {
        this.categorySortOrder[key] = this.categorySortOrder[key] === 'asc' ? 'desc' : 'asc'
      } else {
        this.categorySortKey = key
      }
    },

    /**
     * カテゴリ一覧でカテゴリ選択
     * ページ遷移を考慮してVuexで保存
     */
    selectCategory(categoryId) {
      this.setDashboardSelectedCategoryId(categoryId)
      this.setCategoryId(categoryId)
    },

    /**
     * 動的CSS
     */
    cssCategoryHeaderSort(col) {
      return {
        'sort-active': this.categorySortKey === col,
        'sort-isAsc': this.categorySortOrder[col] === 'asc'
      }
    },

    // 動的css。カテゴリ一覧の選択行
    selectCategoryRow(categoryId) {
      return this.dashboardSelectedCategoryId === categoryId ? 'summary-category-list__row--selected' : ''
    },

    /**
     * カテゴリ一覧の詳細選択時
     * ダッシュボード画面の状態は変更せず、予測画面の設定を変更し、ページ遷移
     */
    transCategory(categoryId) {
      this.setPredictSelectedCategoryId(categoryId)
      this.$router.push('predict')
    },

    changeCategoryFocusByUpKey(list, currentIndex) {
      if (currentIndex === 0) return
      document.getElementById(`category-${currentIndex - 1}`).focus()
    },

    changeCategoryFocusByDownKey(list, currentIndex) {
      if (currentIndex === list.length - 1) return
      document.getElementById(`category-${currentIndex + 1}`).focus()
    },

    /**
     * ----- 店舗用メソッド -----
     */

    /**
     * 店舗一覧取得
     * 合算したサマリデータを付与
     */
    getStores_() {
      const list = []
      const act = this.getStoreSummary_(this.actualSummary)
      const plan = this.getStoreSummary_(this.planSummary)

      _.forEach(this.store, (store, key) => {
        list.push({
          id: store.store_id,
          name: store.store_name,
          actAmount: act[key].amount,
          planAmount: plan[key].amount,
          actProfit: act[key].profit,
          planProfit: plan[key].profit
        })
      })

      return list
    },

    /**
     * サマリデータを店舗単位に合算
     */
    getStoreSummary_(summary) {
      const sSummary = {}
      _.forEach(this.store, (store, key) => {
        sSummary[key] = { amount: 0, profit: 0 }
      })

      _.forEach(summary, (store, key) => {
        const sum = _(store).reduce((result, category) => {
          _.forEach(category, value => {
            result.amount += value.amount
            result.profit += value.profit
          })
          return result
        }, { amount: 0, profit: 0 })

        sSummary[key].amount += sum.amount
        sSummary[key].profit += sum.profit
      })

      // 店舗「全て」を更新
      const allId = '00000'
      _.forEach(sSummary, (store, key) => {
        if (key !== allId) {
          sSummary[allId].amount += store.amount
          sSummary[allId].profit += store.profit
        }
      })

      return sSummary
    },

    /**
     * 店舗一覧のソート順を変更
     */
    setStoreSortOption(key) {
      if (this.storeSortKey == key) {
        this.storeSortOrder[key] = this.storeSortOrder[key] === 'asc' ? 'desc' : 'asc'
      } else {
        this.storeSortKey = key
      }
    },

    /**
     * 店舗一覧で店舗選択
     * ページ遷移を考慮してVuexで保存
     */
    selectStore(storeId) {
      this.setSelectedStoreId(storeId)
      this.setStoreId(storeId)
    },

    /**
     * 動的CSS
     */
    cssStoreHeaderSort(col) {
      return {
        'sort-active': this.storeSortKey === col,
        'sort-isAsc': this.storeSortOrder[col] === 'asc'
      }
    },

    // 動的css。店舗一覧の選択行
    selectStoreRow(storeId) {
      return this.selectedStoreId === storeId ? 'summary-store-list__row--selected' : ''
    },

    changeStoreFocusByUpKey(filters, currentIndex) {
      if (currentIndex === 0) return
      document.getElementById(`store-${currentIndex - 1}`).focus()
    },

    changeStoreFocusByDownKey(filters, currentIndex) {
      if (currentIndex === filters.length - 1) return
      document.getElementById(`store-${currentIndex + 1}`).focus()
    },

    deleteSearchWord() {
      //×アイコンにフォーカスが移ってしまうので、テキストフィールドに再フォーカス
      document.getElementsByClassName('summary-store-list__search-box')[0].focus()
      this.storeSearchWord = ''
    },

    /**
     * ----- 共通メソッド -----
     */

    /**
     * 金額の書式設定
     * 金額は100万円表記で、3桁カンマ付きで後ろに計画達成率を追記する形で返却
     */
    formatMoney(act, plan) {
      let rate = '-';
      if (plan > 0) {
        rate = (act / plan * 100).toFixed(1) + '%'
      }
      return `${common.separate_every_3digits(common.change_value_rate(act))} (${rate})`
    },

    /**
     * 画面表示時に実行
     * 各種データ取得
     */
    async create_() {
      await this.getCategory()
      this.scrollCategory_()

      await this.getStore()
      this.scrollStore_()

      this.getSummary()
    },

    /**
     * カテゴリ一覧を選択行までスクロール
     */
    scrollCategory_() {
      const body = document.querySelector('.summary-category-list__body')
      const idx = _.findIndex(this.categorys, { id: this.dashboardSelectedCategoryId })
      body.scrollTop = body.childNodes[idx].offsetTop - 46
    },

    /**
     * 店舗一覧を選択行までスクロール
     */
    scrollStore_() {
      const body = document.querySelector('.summary-store-list__body')
      const idx = _.findIndex(this.stores, { id: this.selectedStoreId })
      body.scrollTop = body.childNodes[idx].offsetTop - 46
    },
  },

  created() {
    this.create_()
  }
}



// WEBPACK FOOTER //
// ./src/components/aftersale/dashboard/summarylist/summarylist.js